import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import { RemoveItemModalFooter, RemoveItemModalText } from '../ecosystemData/style'
import { getYearFromInput } from 'utils/criterionEHelpers'

const RemoveCriterionEModal = ({ closeModal, confirmRemove, item }) => {
  return (
    <>
      <RemoveItemModalText data-testid="modal-body">
        Are you sure you want to permanently remove the irreplaceability of year{' '}
        <b>{getYearFromInput(item?.year)}</b> from the list? This action cannot be undone.
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  )
}

RemoveCriterionEModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  confirmRemove: PropTypes.func.isRequired,
  item: PropTypes.shape({
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
}

export default RemoveCriterionEModal